const dependencyGmcRequiredType = 'gmc';

export function dataQualityWarning(collectionSections, submissionSections, branches) {
    const flattenedSubmissionSections = submissionSections.map(section => ({
        id: section.id,
        questions: section.questions
    }));

    // Filter to only include submission sections that are part of the selected branches
    const submissionItems = flattenedSubmissionSections
        .filter(section => branches.includes(section.id))
        .flatMap(section => section.questions);

    const submissionItemsId = submissionItems.map(item => item.id);

    // Get all required items from collection based on selected branches
    const findRequiredItems = collectionSections
        .filter(({ id }) => branches.includes(id))
        .flatMap(({ questions }) => questions);

    const requiredItems = findRequiredItems.filter(({ required }) => required).map(item => item.id);

    const contractTypeItem = submissionItems.find(item => item.id === 'contract-type');
    const contractTypeValue = contractTypeItem?.value || null;

    if (contractTypeValue === 'partner-zero-hours' || contractTypeValue === 'zero-hours-contract') {
        requiredItems.push('permanent-working-hours-week');
    } else {
        requiredItems.push('permanent-contracted-hours-week');
    }

    const gmcField = findRequiredItems.filter(({ type }) => type === dependencyGmcRequiredType);

    const missingRequiredItems = requiredItems.filter(id => !submissionItemsId.includes(id));

    let requiredItemsWithOutValues = [];

    for (const id of requiredItems) {
        try {
            const answerObject = submissionItems.find(item => item.id === id);
            const value = answerObject?.value;

            const stringValue = typeof value === 'string' ? value : undefined;
            const numberValue = typeof value === 'number' ? value : undefined;

            if (
                (stringValue === undefined || stringValue === null || stringValue === '') &&
                (numberValue === undefined || numberValue === null || numberValue === '')
            ) {
                requiredItemsWithOutValues.push(id);
            }
        } catch (error) {
            requiredItemsWithOutValues.push(id);
        }
    }

    const staffGroupGpField = submissionItems.find(item => item.id === 'staff-group-gp');
    const isGp = staffGroupGpField?.value === 'gp';

    if (isGp) {
        const gmcId = gmcField[0]?.id;
        if (gmcId && requiredItemsWithOutValues.includes(gmcId)) {
            const validateGmc = shouldValidateGmc(gmcField[0], submissionItems);
            if (!validateGmc) {
                requiredItemsWithOutValues = removeGmcValidation(requiredItemsWithOutValues, gmcId);
            }
        }
    } else {
        // Remove gmc from required if not a GP
        requiredItemsWithOutValues = requiredItemsWithOutValues.filter(item => item !== 'gmc');
    }

    return requiredItemsWithOutValues.length > 0 || missingRequiredItems.length > 0;
}

function removeGmcValidation(array, removeId) {
    return array.filter(value => value !== removeId);
}

function shouldValidateGmc(gmcField, submissionItems) {
    const requiredDependency = submissionItems.find(
        item => item.id === gmcField.required?.question_id
    );

    if (!requiredDependency) return false;

    return gmcField.required.value === requiredDependency.value;
}
